"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const CodeEditor_1 = require("./CodeEditor");
const react_use_1 = require("react-use");
// interface IState {}
exports.PreviewModal = (_a) => {
    var { title = 'Email preview' } = _a, props = tslib_1.__rest(_a, ["title"]);
    const [showCode, toggleCode] = react_use_1.useToggle(false);
    if (!props.isOpen) {
        return null;
    }
    return (react_1.default.createElement(react_2.OsmosysModal, { osysName: "PreviewModal", size: "lg", centered: true, isOpen: props.isOpen, toggle: () => {
            props.onClose();
        }, unmountOnClose: true },
        react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => props.onClose() }, title),
        react_1.default.createElement(reactstrap_1.ModalBody, null, showCode ? (react_1.default.createElement(react_2.OsmosysDiv, { style: { height: 400 }, className: "w-100 " },
            react_1.default.createElement(CodeEditor_1.CodeEditor, { value: props.html, onChange: () => { }, language: "html" }))) : (react_1.default.createElement("iframe", { className: "border rounded w-100 mb-0 d-block", style: { height: 400 }, src: `data:text/html;\
charset=utf-8,${encodeURIComponent(props.html)}` }))),
        react_1.default.createElement(reactstrap_1.ModalFooter, null,
            react_1.default.createElement(react_2.OsmosysDiv, { className: "w-100", flexRow: true },
                react_1.default.createElement(react_2.OsmosysDiv, { flexFill: true },
                    react_1.default.createElement(reactstrap_1.Button, { color: "light", className: "w-100", target: "_blank", download: true, tag: "a", href: `data:text/html;charset=UTF-8,${encodeURIComponent(props.html)}` }, "Download")),
                react_1.default.createElement(react_2.OsmosysDiv, null,
                    react_1.default.createElement(reactstrap_1.Button, { color: "light", className: "w-100", target: "_blank", onClick: toggleCode }, !showCode ? 'View code' : 'Hide code'))))));
};
//# sourceMappingURL=PreviewModal.js.map